<template lang="html">
  <div>
    <v-toolbar id="header-navbar" white class="header-text" height="125">
      <v-toolbar-title class="dark--text logo">
        <router-link to="/">
          <img :src="logo" alt="Blitzoo" />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- <v-toolbar-items class="hidden-sm-only"> -->
      <v-toolbar-items class="hidden-md-and-down">
        <v-btn to="/about" flat>About</v-btn>
        <v-menu
          open-on-hover
          close-on-click
          close-on-content-click
          offset-y
          key="menu-game"
          ref="parentMenu"
        >
          <v-btn flat slot="activator" to="/games">Games <v-icon>arrow_drop_down</v-icon></v-btn>
          <v-list class="header-text">
            <v-list-tile
              v-for="(item, i) in gamesNav"
              :key="i"
              :to="item.link"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>

              <!-- Nested Menu -->
              <!-- <v-menu
                offset-x
                open-on-hover
                close-on-click
                close-on-content-click
                v-else
              >
                <v-list-tile slot="activator">
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  <v-list-tile-action class="justify-end" v-if="item.title === 'Social'">
                    <v-icon>play_arrow</v-icon>
                  </v-list-tile-action>
                </v-list-tile> -->
                <!-- add slot="activator" to v-list dense to deactivate parent menu but ugly -->
                <!-- <v-list dense>
                  <v-list-tile @click="route" v-for="game in socialNav" :key="game.title" :to="game.link" class="header-text">
                    <v-list-tile-title>{{ game.title }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu> -->
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu offset-y open-on-hover>
          <v-btn flat slot="activator" to="/working-at-blitzoo">Careers <v-icon>arrow_drop_down</v-icon></v-btn>
          <v-list class="header-text">
            <v-list-tile
              v-for="(item, i) in careerNav"
              :key="i"
              :to="item.link"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn to="/contact" flat>Contact</v-btn>
      </v-toolbar-items>
      <v-toolbar-side-icon white @click.stop="sideNav = !sideNav" class="hamburgerIcon"></v-toolbar-side-icon>
      <!-- class="hidden-lg-and-up" -->
    </v-toolbar>

    <v-navigation-drawer temporary v-model="sideNav" absolute white>
      <v-list v-for="link in links" :key="link.title">
        <v-list-tile :key="link.title" @click="menuClicked(link.title)" v-if="!link.items">
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ link.title }}</v-list-tile-title>
        </v-list-tile>

        <v-list-group
          :prepend-icon="link.icon"
          :id="link.icon"
          v-else
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ link.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <v-list-tile
            v-for="subItem in link.items"
            :key="subItem.title"
            @click="menuClicked(subItem.title)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      admins: [
        ['Management', 'people_outline'],
        ['Settings', 'settings']
      ],
      cruds: [
        ['Create', 'add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'update'],
        ['Delete', 'delete']
      ],
      sideNav: false,
      links: [
        { title: 'Home', icon: 'home' },
        { title: 'About', icon: 'info' },
        {
          title: 'Games',
          icon: 'games',
          items: [
            // { title: 'Land-Based' },
            { title: 'Social' }
          ]
        },
        {
          title: 'Careers',
          icon: 'work',
          items: [
            { title: 'Working at Blitzoo' },
            { title: 'Open Positions' }
          ]
        },
        { title: 'Contact', icon: 'email' }
      ],
      gamesNav: [
        // { title: 'Land-Based', link: '/land-based-games' },
        { title: 'Social', link: '/social-games' }
        // { title: 'DSD', link: '/ding-slots-ding' },
        // { title: 'SMVS', link: '/show-me-vegas-slots' }
      ],
      careerNav: [
        { title: 'Working at Blitzoo', link: '/working-at-blitzoo' },
        { title: 'Open Positions', link: '/careers' }
      ],
      socialNav: [
        { title: 'Show Me Vegas Slots', link: '/show-me-vegas-slots' },
        { title: 'Ding Slots Ding!', link: '/ding-slots-ding' }
      ],
      logo: require('../../assets/Blitzoo_Logo.png'),
      navbar: require('../../assets/nav-bar.png')
    }
  },
  watch: {
    // deactivate () {
    //   console.log('deactivate')
    // }
  },
  methods: {
    menuClicked (link) {
      if (link && typeof link === 'object' && link.link) {
        this.$router.push(link.link)
        this.sideNav = false
        return
      }

      const routeStr = typeof link === 'object' && link != null && link.title
        ? link.title
        : (typeof link === 'string' ? link : '')
      let route = routeStr.toLowerCase()
      if (route === 'social') {
        route = 'social-games'
      } else if (route === 'working at blitzoo') {
        route = 'working'
      } else if (route === 'open positions') {
        route = 'careers'
      }
      this.$router.push({ name: `${route}` })
    },
    route () {
      if (arguments.length) {
        const parentMenu = this.$refs.parentMenu
        parentMenu.isActive = false
      }
    }
  },
  mounted () {
    // let winWidth = document.documentElement.clientWidth

    // resizing UI; commented out for now to push 2 new jobs
    window.onresize = function () {
      // currentWidth = window.innerWidth
      // currentHeight = window.innerHeight
      // console.log('Width: ' + currentWidth)
      // console.log('Height: ' + currentHeight)

      // winWidth = document.documentElement.clientWidth
      // console.log('Window Width: ' + winWidth)
      // console.log('===')
      //
      // if (winWidth < 830) {
      //   console.log('reached')
      //   document.querySelector('.v-toolbar__content').style.width = winWidth + 40 + 'px'
      // }

      // if (currentWidth < 830 && currentWidth >= 800) {
      //   Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
      //     el.style.width = '80%'
      //   })
      // } else if (currentWidth < 800 && currentWidth >= 780) {
      //   Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
      //     el.style.width = '70%'
      //   })
      // } else if (currentWidth < 780) {
      //   Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
      //     el.style.width = '60%'
      //   })
      // }
    }
  },
  beforeUpdate () {
    let el = document.querySelector('#games .v-list__group__header .v-list__group__header__prepend-icon .v-icon')
    el.style.color = 'white'

    let elDropdown = document.querySelector('#games .v-list__group__header .v-list__group__header__append-icon .v-icon')
    elDropdown.style.color = 'white'

    let elWork = document.querySelector('#work .v-list__group__header .v-list__group__header__prepend-icon .v-icon')
    elWork.style.color = 'white'

    let elWorkDropdown = document.querySelector('#work .v-list__group__header .v-list__group__header__append-icon .v-icon')
    elWorkDropdown.style.color = 'white'
  }
}
</script>

<style lang="scss" scoped>
.theme--light.v-toolbar {
  background-color: #ffffff;
}

#header-navbar {
  background-image: url('../../assets/nav-bar.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.logo {
  height: 80%;
  position: absolute;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%);
}

.logo img {
  // display: flex;
  // align-items: center;
  height: 100%;
}

.header-text {
  font-family: museo-slab, serif;
  font-style: normal;
  // font-weight: 800; overrides by v-btn
}

.v-btn {
  font-weight: 800;
  font-size: 20px;
}

.application .theme--light.v-btn, .theme--light .v-btn {
  // color: #335091;
  color: white;
}

.v-menu__content {
  margin-top: -1.5rem !important;
}

.theme--light {
  .v-list {
    background: #3d00c4;
    color: white;
    font-family: 'open-sans-semibold', serif;
  }

  .v-icon {
    color: white;
  }
}

.theme--light.v-icon {
  color: white;
}

.v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
  background-color: #3d00c4;
  z-index: 9999;
}

#landBased {
  padding-left: 16px;
}

@media only screen and (max-width: 1363px) {
  .hidden-md-and-down {
    display: none!important;
  }
}

@media only screen and (min-width: 1363px) {
  .hamburgerIcon {
    display: none !important;
  }
}
</style>
